import type { Implementer } from '@volkswagen-onehub/oneaudi-os-onesight';
import type { TrackingServiceV3 } from '../feature-service-types';
import {
  createAndBootstrapTrackingService,
  NoOperationTrackingService,
} from '../feature-service-types';

export const APP_ID = __FEATURE_APP_NAME__;
export const IMPLEMENTER = 39 as Implementer;

export const createTrackingService = (appId: string = APP_ID): TrackingServiceV3 => {
  if (typeof window === 'undefined') {
    return new NoOperationTrackingService(appId);
  }

  return createAndBootstrapTrackingService({
    appId,
    appName: __FEATURE_APP_NAME__,
    appVersion: __FEATURE_APP_VERSION__,
    implementer: IMPLEMENTER,
  });
};

const emptyCarouselAttributes = () => ({
  componentName: 'pencil-banner',
  elementName: '',
  label: '',
  clickID: '',
  pos: '',
  targetURL: '',
  value: '',
});

type TrackingEventData = {
  eventInfo: {
    eventAction: string;
    eventName: string;
  };
  attributes?: {
    componentName?: string;
    elementName?: string;
    label?: string;
    clickID?: string;
    pos?: string;
    targetURL?: string;
    value?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

export const createFeatureAppReadyEvent = (): TrackingEventData => ({
  eventInfo: {
    eventAction: 'feature_app_ready',
    eventName: 'pencil banner - feature app ready',
  },
  attributes: emptyCarouselAttributes(),
});

export const trackFeatureAppReadyEvent = (trackingService: TrackingServiceV3) => {
  trackingService.track(createFeatureAppReadyEvent());
};

export const trackBannerClickEvent = (
  trackingService: TrackingServiceV3,
  trackingEvent: TrackingEventData,
) => {
  trackingService.track(trackingEvent);
};

export const trackCtaClickEvent = (
  trackingService: TrackingServiceV3,
  trackingEvent: TrackingEventData,
) => {
  trackingService.track(trackingEvent);
};
